module.exports = __webpack_public_path__ + "img/tech.b7cbde40.jpg";